import { Box } from "@material-ui/core"
import React from "react"

export const Row = (props) => <Box display="flex" {...props} />
export const Cell = (props) => <Box flex={1} margin="0.5em" {...props} />
